/**
 * Canonical scoring language for the marketing site.
 * Primary: Independence Score (0–100) — higher = more independent.
 * Secondary: AI Dependency Level (L1–L5) — higher = less reliant on AI (growth ladder).
 * Session rubric: 1–5 per criterion per practice — not the same as Independence Score.
 *
 * Landing page UI keeps this jargon in FAQ only.
 */

export const SCORING_EXPLAIN_FAQ =
  'Independence Score (0–100) tracks how independently you think over time; higher is better. AI Dependency Level (L1–L5) is a simpler label for the same growth ladder: L1 means you mostly copy AI answers, L5 means you can handle a fresh problem on your own. Session rubric dots (1–5 per criterion) score a single practice only; they are not your Independence Score.';
